module.exports = __webpack_public_path__ + "static/img/Planificaciones_5_formatos@4x.c3cc9280.png";